import {
  BorderStyleProperty,
  MarginSizeProperty,
  ProductColor,
  SizeProperty,
  Flex as WebFlex,
} from '@aloft/toolkit-sui';
import { View as PDFFlex } from '@react-pdf/renderer';
import type { Style } from '@react-pdf/types';

import { PropsWithChildren } from 'react';

import { useIsPDF } from '../internal/useIsPDF.ts';

// XXX: this interface is kind of hideous. the consumer should only be able to
// ask things that make sense in both the PDF and web contexts

type Props = PropsWithChildren<{
  // for web
  alignItems?:
    | 'center'
    | 'space-around'
    | 'space-between'
    | 'space-evenly'
    | 'stretch'
    | 'flex-end'
    | 'flex-start'
    | 'baseline';
  backgroundColor?: ProductColor;
  borderColor?: ProductColor;
  borderRadius?: SizeProperty;
  borderWidth?: SizeProperty;
  borderStyle?: BorderStyleProperty;
  columnGap?: SizeProperty;
  flexDirection?: 'column' | 'column-reverse' | 'row' | 'row-reverse' | undefined;
  flexGrow?: number;
  flexShrink?: number;
  gap?: SizeProperty;
  height?: SizeProperty;
  justifyContent?:
    | 'center'
    | 'space-around'
    | 'space-between'
    | 'space-evenly'
    | 'stretch'
    | 'flex-end'
    | 'flex-start'
    | 'baseline';
  marginBottom?: MarginSizeProperty;
  marginTop?: MarginSizeProperty;
  padding?: SizeProperty;
  width?: SizeProperty;
  wrap?: boolean;

  // for PDF
  break?: boolean;
  style?: Style | Style[];
}>;

export const Flex = (props: Props) => {
  const { children, ...rest } = props;

  if (useIsPDF()) return <PDFFlex {...rest}>{children}</PDFFlex>;
  return <WebFlex {...rest}>{children}</WebFlex>;
};
